<template>
  <div
    class="components-footer"
    :style="{
      background: $route.path == '/cn/sustain' ? '#ffffff' : '#f5f5f7'
    }"
    :class="{ small: path == '/cn/taskDetail' || path == '/cn/mycloud' }"
  >
    <div class="inner" v-if="path != '/cn/taskDetail' && path != '/cn/mycloud'">
      <img src="static/images_20230306/footer/4.webp" class="bg" alt="" />
      <div class="rightImg">
        <div>
          <img src="/static/images_v5/footer/1.webp" alt="" />
        </div>
        <div>
          <img src="/static/images_20230306/footer/1.webp" alt="" />
          <img src="/static/images_20230306/footer/2.webp" alt="" />
          <img src="/static/images_20230306/footer/3.webp" alt="" />
        </div>
      </div>
      <div class="leftText">
        <div>
          联系电话：027-63499511 技术支持：support@daspatial.com 销
          售：sales@daspatial.com
        </div>
        <div style="margin-top: 5px;">
          合作邮箱：withdas168@daspatial.com
        </div>
      </div>
      <div v-if="language == 'Ch'" class="one">
        <!-- <div style="position: absolute; top: 0">
          <img alt="大势智慧" src="/static/images/titleimg.webp" />
        </div> -->
        <img alt="大势智慧" src="/static/images_20230306/footer/logo2.webp" />
        <!--<div style="position: absolute; bottom: 40px"><img alt="大势智慧微信公众号" src="/static/images/4.webp"></div>-->
        <!-- <div class="group"> -->

        <!-- <div>
            <img
              v-if="ercodehover == 1"
              class="ercode"
              alt="大势智慧微信公众号"
              src="/static/images/230.webp"
            />
            <img
              @mouseover="ercodehover = 1"
              @mouseleave="ercodehover = ''"
              alt="大势智慧微信公众号"
              :src="
                '/static/images/' +
                  (ercodehover == 1 ? '227_1' : '227') +
                  '.webp'
              "
            />
          </div> -->
        <!--<div>-->
        <!--<img-->
        <!--v-if="ercodehover == 2"-->
        <!--class="ercode"-->
        <!--alt="大势智慧抖音"-->
        <!--src="/static/images/231.webp"-->
        <!--/>-->
        <!--<img-->
        <!--@mouseover="ercodehover = 2"-->
        <!--@mouseleave="ercodehover = ''"-->
        <!--alt="大势智慧抖音"-->
        <!--:src="-->
        <!--'/static/images/' +-->
        <!--(ercodehover == 2 ? '228_1' : '228') +-->
        <!--'.webp'-->
        <!--"-->
        <!--/>-->
        <!--</div>-->
        <!--<div>-->
        <!--<img-->
        <!--v-if="ercodehover == 3"-->
        <!--class="ercode"-->
        <!--alt="大势智慧抖音"-->
        <!--src="/static/images/232.webp"-->
        <!--/>-->
        <!--<img-->
        <!--@mouseover="ercodehover = 3"-->
        <!--@mouseleave="ercodehover = ''"-->
        <!--alt="大势智慧抖音"-->
        <!--:src="-->
        <!--'/static/images/' +-->
        <!--(ercodehover == 3 ? '228_1' : '228') +-->
        <!--'.webp'-->
        <!--"-->
        <!--/>-->
        <!--</div>-->
        <!-- <div style="margin-left: 20px">
            <img
              @mouseover="ercodehover = 4"
              @mouseleave="ercodehover = ''"
              @click="go('https://www.zhihu.com/org/da-shi-zhi-hui')"
              alt="大势智慧知乎"
              :src="
                '/static/images/' +
                  (ercodehover == 4 ? '229_1' : '229') +
                  '.webp'
              "
            />
          </div> -->
        <!-- </div> -->
      </div>
      <div v-else-if="language == 'En'" class="one" style="height: 110px">
        <div style="position: absolute; top: 0">
          <img alt="大势智慧" src="/static/images/titleimg_3.webp" />
        </div>
      </div>

      <div class="twoBox">
        <div
          v-if="language == 'Ch'"
          class="two hover"
          style="margin-right: 81px"
        >
          <div class="title">智能产品</div>

          <router-link to="/cn/doublefish8x">
            <div class="text">双鱼系列</div>
          </router-link>
          <router-link to="/cn/dshot">
            <div class="text">定拍DShot</div>
          </router-link>
          <router-link to="/cn/rtk">
            <div class="text">MinRTK</div>
          </router-link>

          <router-link to="/cn/wisdomR100">
            <div class="text">智影 R100</div>
          </router-link>
          <router-link to="/cn/wisdomS100">
            <div class="text">智影 S100</div>
          </router-link>
          <!-- <router-link to="/cn/solnsight">
            <div class="text">速影 L100</div>
          </router-link> -->
          <router-link to="/cn/hawkeye">
            <div class="text">鹰眼</div>
          </router-link>
          <router-link to="/cn/gcluster">
            <div class="text">重建大师</div>
          </router-link>
          <router-link to="/cn/cluster-satellite">
            <div class="text">重建大师卫星版</div>
          </router-link>
          <a href="https://www.get3d.cn/" target="_blank">
            <div class="text">云端地球</div>
          </a>
          <router-link to="/cn/nongchang">
            <div class="text">重建农场</div>
          </router-link>
          <router-link to="/cn/farmsecurity">
            <div class="text">重建农场信创版</div>
          </router-link>
          <router-link to="/cn/farmlite">
            <div class="text">重建农场便携版</div>
          </router-link>
          <router-link to="/cn/mofang">
            <div class="text">模方</div>
          </router-link>
          <router-link to="/cn/dasviewer">
            <div class="text">DasViewer</div>
          </router-link>
          <router-link to="/cn/dasmesh">
            <div class="text">网格大师</div>
          </router-link>
        </div>
        <div
          v-if="language == 'Ch'"
          class="two hover"
          style="margin-right: 39px"
        >
          <div class="title">行业应用解决方案</div>
          <router-link to="/cn/nrs">
            <div class="text">自然资源监管</div>
          </router-link>
          <router-link to="/cn/mine">
            <div class="text">矿山监管</div>
          </router-link>
          <router-link to="/cn/farmhouse">
            <div class="text">
              农房核查
            </div>
          </router-link>
          <router-link to="/cn/emergency">
            <div class="text" style="margin-bottom: 45px;">
              灾害现场快速三维态势感知
            </div>
          </router-link>
          <div class="title">文化遗产解决方案</div>
          <div
            class="text"
            @click="$router.push('/cn/wise')"
            style="margin-bottom: 44px;"
          >
            智慧文旅
          </div>
          <div class="title">数据生产解决方案</div>
          <router-link to="/cn/service">
            <div class="text">数据服务</div>
          </router-link>
          <router-link to="/cn/nongchang">
            <div class="text">数据中心</div>
          </router-link>
          <!-- <router-link to="/">
            <div class="text">行业应用解决方案</div>
          </router-link>
          <router-link to="/">
            <div class="text">数据生产解决方案</div>
          </router-link>
          <router-link to="/cn/nongchang">
            <div class="text">数据中心解决方案</div>
          </router-link>
          <router-link to="/cn/service">
            <div class="text">数据服务</div>
          </router-link> -->
        </div>
        <div
          v-if="language == 'Ch'"
          class="two hover"
          style="margin-right: 100px"
        >
          <div class="title">服务支持</div>
          <router-link to="/cn/sustain?scroll=true&scrollPos=communicate">
            <div class="text">技术支持</div>
          </router-link>
          <router-link to="/cn/sustain?scroll=true&scrollPos=communicate">
            <div class="text">我要投诉</div>
          </router-link>
          <router-link to="/cn/sustain?scroll=true&scrollPos=communicate">
            <div class="text">软件建议</div>
          </router-link>
          <router-link to="/cn/faq">
            <div class="text">常见问题</div>
          </router-link>
          <router-link to="/cn/sustain?scroll=true&scrollPos=question">
            <div class="text">教学视频</div>
          </router-link>
        </div>
        <div
          v-if="language == 'Ch'"
          class="two hover"
          style="margin-right: 82px"
        >
          <div class="title">下载中心</div>
          <router-link to="/cn/download?active=3">
            <div class="text">重建大师</div>
          </router-link>
          <router-link to="/cn/download?active=4">
            <div class="text">模方</div>
          </router-link>
          <router-link to="/cn/download?active=6">
            <div class="text">DasViewer</div>
          </router-link>
          <router-link to="/cn/download?active=10">
            <div class="text">大势认证管理服务</div>
          </router-link>
          <router-link to="/cn/download?active=9">
            <div class="text">大势云观</div>
          </router-link>
          <router-link to="/cn/download?active=5">
            <div class="text">贴图大师</div>
          </router-link>
          <!-- <router-link to="/cn/download?active=1">
            <div class="text">双鱼系列</div>
          </router-link> -->
          <router-link to="/cn/download?active=8">
            <div class="text">建模技术规范</div>
          </router-link>
        </div>
        <!-- <div
          style="margin-right: 70px"
          v-if="language == 'Ch'"
          class="two hover"
        >
          <div class="title">服务与应用</div>
          <router-link to="/cn/engin">
            <div class="text">G-Engine</div>
          </router-link>
          <router-link to="/cn/service">
            <div class="text">数据服务</div>
          </router-link>
          <router-link to="/cn/cloud">
            <div class="text">云端数据</div>
          </router-link>
          <router-link to="/cn/wise">
            <div class="text">智慧文博</div>
          </router-link>
          <div class="title" style="margin-top: 44px">下载与帮助</div>
          <router-link to="/cn/download">
            <div class="text">下载中心</div>
          </router-link>
          <router-link to="/cn/faq">
            <div class="text">常见问题</div>
          </router-link>
        </div> -->
        <div
          style="margin-right: 152px"
          v-if="language == 'Ch'"
          class="two hover"
        >
          <div class="title">关于我们</div>
          <router-link to="/cn/about">
            <div class="text" rel="nofollow">公司介绍</div>
          </router-link>
          <router-link to="/cn/enterpriseCooperation">
            <div class="text" rel="nofollow">代理商政策</div>
          </router-link>
          <router-link to="/cn/cases">
            <div class="text" rel="nofollow">合作案例</div>
          </router-link>

          <router-link to="/cn/news">
            <div class="text" rel="nofollow">新闻中心</div>
          </router-link>
          <a
            href="https://www.zhipin.com/gongsir/254ee1f246c4427d1nF80tq9FQ~~.html?ka=company-jobs"
            target="_blank"
            rel="nofollow"
          >
            <div class="text">加入我们</div>
          </a>
        </div>
        <div v-if="language == 'Ch'" class="two" style="width: 288px">
          <div class="title">联系我们</div>
          <div class="text" style="display: flex">
            <!-- <div style="width: 62px">总部：</div> -->
            <div>湖北省武汉市江夏区光谷大道77号金融港B2栋4层</div>
          </div>
          <!-- <div class="text" style="display: flex">
            <div style="width: 46px">总机：</div>
            <div>
              027-63499511
            </div>
          </div> -->
          <!-- <div class="text saoma">
            <img
              style="width: 100px;height: 100px;object-fit: cover;"
              src="/static/images_v5/footer/1.jpg"
              alt=""
            />
            <div>
              <div>如有更多问题</div>
              <div>请扫码咨询</div>
            </div>
          </div> -->
        </div>
        <div
          v-else-if="language == 'En'"
          class="two"
          style="position: absolute; bottom: 30px; height: auto; left: 0; margin-left: 0; font-family: en1 !important;"
        >
          <div class="text" style="display: flex;margin-top: 0px">
            <div style="width: 55px;">Email:</div>
            support@daspatial.com<br />sales@daspatial.com
            <span style="margin-left: 40px">Tel: 0086-27-63499511</span>
          </div>
          <div class="text" style="display: flex;margin-top: 2px">
            <div style="width: 75px;">Address:</div>
            <div>
              8th Floor, B18 Building, Opticals Valley avenue, Jiangxia
              district, Wuhan, Hubei, China.
            </div>
          </div>
        </div>
      </div>
      <!-- <img
        v-if="language == 'Ch'"
        style="position: absolute; bottom: 40px; right: 0"
        src="/static/images/9.webp"
      /> -->
      <!-- <img
        v-else-if="language == 'En'"
        style="position: absolute; bottom: 40px; right: 0; width: 350px"
        src="/static/images/9.webp"
      /> -->
    </div>
    <div
      v-if="language == 'Ch'"
      class="bottom"
      :class="{ small: path == '/cn/taskDetail' || path == '/cn/mycloud' }"
    >
      <div>
        <span
          >Copyright © 2015-{{
            new Date().getFullYear()
          }}
          武汉大势智慧科技有限公司</span
        >
        <a class="blank" href="https://beian.miit.gov.cn/" target="_blank"
          >鄂ICP备15001704号-1</a
        >
      </div>
      <div>
        <router-link to="/cn/privacy" target="_blank">
          <div
            class="text"
            style="color: #b3b3b3; display: inline-block; margin-left: 40px; text-decoration: underline"
            rel="nofollow"
          >
            隐私政策
          </div>
        </router-link>
        <router-link to="/cn/legal" target="_blank">
          <div
            class="text"
            style="color: #b3b3b3; display: inline-block; margin-left: 20px; text-decoration: underline"
            rel="nofollow"
          >
            服务条款
          </div>
        </router-link>
      </div>
    </div>
    <div
      v-else-if="language == 'En'"
      class="bottom"
      style=" font-family: en1 !important;"
    >
      © 2015-2020Daspatial Technology Co.,Ltd.<router-link to="/en/privacy">
        <div
          class="text"
          style="color: #b3b3b3; display: inline-block; margin-left: 40px; text-decoration: underline"
          rel="nofollow"
        >
          Privacy Policy
        </div>
      </router-link>
      <router-link to="/en/legal">
        <div
          class="text"
          style="color: #b3b3b3; display: inline-block; margin-left: 20px; text-decoration: underline"
          rel="nofollow"
        >
          Terms of Service
        </div>
      </router-link>
    </div>

    <transition name="el-fade-in">
      <div
        v-show="showtotop"
        @click="goToTop"
        style="z-index: 10; position: fixed; right: 22px; border: 1px solid #ccc; height: 50px; width: 50px; font-size: 30px; color: #A6A6A6; text-align: center; cursor: pointer; background-color: white; line-height: 50px"
        :style="{ bottom: path == '/cn/skyCloud' ? '260px' : '100px' }"
      >
        <i class="el-icon-arrow-up"></i>
      </div>
    </transition>
  </div>
</template>

<script>
import userApi from "@/api/user";
import $ from "jquery";

export default {
  name: "components-header",
  data() {
    return {
      language: global.apis.getLanguage(),
      showtotop: false,
      interval: {},
      ercodehover: "",
      path: ""
    };
  },
  watch: {
    // 监控路由变化
    $route: function() {
      this.language = global.apis.getLanguage();
      this.path = this.$router.currentRoute.path;
    }
  },
  created() {
    this.language = global.apis.getLanguage();
    this.path = this.$router.currentRoute.path;

    let _this = this;
    this.interval = setInterval(function() {
      _this.language = global.apis.getLanguage();
    }, 500);
  },
  mounted() {
    this.path = this.$router.currentRoute.path;
    window.addEventListener("scroll", this.showIcon);
  },
  methods: {
    go(path) {
      window.open(path);
    },
    showIcon() {
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 200
      ) {
        this.showtotop = true;
      } else {
        this.showtotop = false;
      }
    },
    goToTop: function() {
      $("html,body").animate(
        {
          scrollTop: 0
        },
        500
      );
    }
  }
};
</script>

<style scoped>
.components-footer {
  /* background-color: #212121; */
  padding: 150px 0 140px;
  min-width: 1200px;
  z-index: 1;
  position: relative;
  /*background: url('/static/images/221.webp') no-repeat center 0;*/
  /*background-size: cover;*/
}

.components-footer.small {
  padding-top: 20px;
  padding-bottom: 20px;
}

.inner {
  position: relative;
  margin: 0 auto;
  width: 1200px;
  color: white;
  /* display: flex; */
  /* border-bottom: 1px solid white; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
  padding-bottom: 177px;
}

.inner > .bg {
  position: absolute;
  right: -360px;
  top: -110px;
  width: 828px;
  height: auto;
  pointer-events: none;
}

.inner .one {
  /* width: 200px; */
  position: relative;
  padding-top: 26px;
  border-top: 1px solid rgba(0, 0, 0, 0.26);
}

.inner .one > img {
  display: block;
  margin-left: 16px;
}

.twoBox {
  display: flex;
  margin: 18px 0 0 16px;
}

.rightImg {
  position: absolute;
  right: 0;
  bottom: 6px;
  overflow: hidden;
}

.leftText {
  position: absolute;
  left: 16px;
  bottom: 10px;
}

.leftText > div {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}

.rightImg > div:nth-child(1) {
  display: flex;
  justify-content: flex-end;
  margin-right: 24px;
}

.rightImg > div:nth-child(1) img {
  width: 104px;
  height: auto;
  object-fit: cover;
}

.rightImg > div:nth-child(2) {
  position: relative;
  padding: 4px 160px 4px 0;
  margin-top: 30px;
}

.rightImg > div:nth-child(2) > img:nth-child(1) {
  display: block;
}

.rightImg > div:nth-child(2) > img:nth-child(2) {
  position: absolute;
  right: 54px;
  width: 101px;
  height: auto;
  bottom: 0;
  z-index: 3;
}

.rightImg > div:nth-child(2) > img:nth-child(3) {
  position: absolute;
  right: 0;
  width: 95px;
  height: auto;
  top: -2px;
  z-index: 2;
}

/* .inner .one .group {
  width: 100%;
  display: flex;
  position: absolute;
  bottom: 0;
}
.inner .one .group > div {
  position: relative;
}
.inner .one .group .ercode {
  position: absolute;
  top: -115px;
  left: -32px;
} */
/* .inner .two {
  height: 425px;
} */
.inner .two .title {
  font-size: 12px;
  /* padding-bottom: 10px; */
  color: rgba(0, 0, 0, 0.9);
  height: 20px;
  line-height: 20px;
}

.inner .two .text {
  font-size: 12px;
  /* color: #b3b3b3; */
  color: rgba(0, 0, 0, 0.6);
  margin-top: 12px;
  line-height: 22px;
  white-space: nowrap;
}

.inner .two.hover .text {
  cursor: pointer;
  height: 19px;
}

/* .inner .two.hover .text:hover {
  color: white;
} */
.bottom {
  width: 1200px;
  margin: 11px auto 0;
  display: flex;
  justify-content: space-between;
  /* color: #b3b3b3; */
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  padding: 0 16px;
  box-sizing: border-box;
  /* text-align: center; */
}

.bottom.small {
  margin-top: 0;
}

.bottom a,
.bottom span {
  display: inline-block;
  height: 20px;
  line-height: 20px;
}

/* .bottom .text:hover {
  color: white !important;
} */
.blank {
  color: rgba(0, 0, 0, 0.6);
}

/* .blank:hover {
  color: white;
} */
.saoma {
  display: flex;
}

.saoma > img {
  width: 140px;
  height: 140px;
  object-fit: cover;
}

.saoma > div {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-left: 10px;
}

.saoma > div > div:nth-child(2) {
  margin-bottom: -5px;
}

.cp {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue